import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RDS_DIALOG_DATA, RdsDialogRef } from '@rds/angular-components';

import { DesignerSuiteService } from 'src/app/modules/designer/service/designer-suite.service';
import { TabCloseService } from 'src/app/service/tab-close.service';
import { NO_ACCESS_DIALOG } from 'src/app/utility/constant/config';

export type noAccessPayloadType = {
    accessLink: string;
    message: string;
};

@Component({
    selector: 'app-no-access-dialog',
    templateUrl: './no-access-dialog.component.html',
    styleUrls: ['./no-access-dialog.component.scss'],
    standalone: false,
})
export class NoAccessDialogComponent implements OnInit {
    private readonly landingPageUrl = import.meta.env.NG_APP_LANDING_PAGE_URL;
    protected readonly data: any = inject(RDS_DIALOG_DATA);
    noAccessConstant = NO_ACCESS_DIALOG;
    navigateBack = false;

    public readonly rdsDialogRef =
        inject<RdsDialogRef<NoAccessDialogComponent>>(RdsDialogRef);
    private readonly designerService = inject(DesignerSuiteService);
    constructor(
        private readonly route: Router,
        private readonly tabCloseService: TabCloseService
    ) {}

    navigateToProjectListing() {
        globalThis.location.href = this.landingPageUrl + '/app/project';
    }

    goBackToProject() {
        this.rdsDialogRef.close(true);
        this.tabCloseService.closeTab();
    }

    ngOnInit(): void {
        if (this.data && this.data?.['displayFor'] === 'access_denied') {
            this.noAccessConstant.accessHyperLink = '';
            this.noAccessConstant.accessLinkText = '';
            this.noAccessConstant.dialogContentText =
                this.data.dialogContentText;
            this.noAccessConstant.dialogHeaderText = this.data.dialogHeaderText;
            this.navigateBack = this.data.navigateBack || false;

            if (this.data.projectMetadata) {
                this.designerService.setData(this.data.projectMetadata);
                this.tabCloseService.init();
            }
        }
    }
}
